<template>
  <div class="overlay-loading" v-show="isWaitingForServer"></div>
  <div class="jackpot-actions">
    <h2>Select Slottery game</h2>
    <ul class="list-buttons">
      <li v-for="game in games" v-bind:key="game.id">
        <button
          class="button"
          @click.stop="chooseGame(game)"
          :class="
            chosenGame != null && game.id == chosenGame.id
              ? 'disabled'
              : 'enabled'
          "
        >
          {{ game.name }} - {{ formatPrice(game) }} SEK
        </button>
      </li>
    </ul>
    <div class="unfinished" v-if="unfinishedTickets.length > 0">
      <h2>Unfinished tickets</h2>
      <ul class="unfinished-list">
        <li
          v-for="ticket in unfinishedTickets"
          v-bind:key="ticket.correlationId"
        >
          ID {{ ticket.correlationId }}
          <span v-if="ticket.tickets[0].autoCompleteOn"
            >- AutoCompletes on:
            {{ $filters.formatDate(ticket.tickets[0].autoCompleteOn) }}</span
          >
          - <a href="#" @click.stop="finalizeTicket(ticket)">Finalize</a>
        </li>
      </ul>
    </div>
    <div class="ticket-buy" v-if="chosenGame != null">
      <button class="button" @click.stop="buy()">Buy ticket</button>
    </div>
    <div class="ticket-result" v-if="lastTicketResult">
      <h2>Ticket result</h2>
      <strong>Result:</strong> {{ lastTicketResult.prizeValue }} SEK
      <br />
      <InstantLayoutAnimation
        :col="5"
        :row="5"
        :lastTicketResult="lastTicketResult"
      />
      <InstantLayoutGenerator :lastTicketResult="lastTicketResult" />
    </div>
  </div>
</template>

<script>
import store from "../store.js";
import {
  updateBalance,
  getUnfinishedTickets,
  finalizeGameWithCorrelationId,
  getInstantTicket,
} from "../api.js";
import { unifiedBuy } from "../utils/unifiedBuy.js";
import { formatPrice, getSuggestedWager } from "../utils/gameHelper.js";
import InstantLayoutGenerator from "./instantLayout/InstantLayoutGenerator.vue";
import InstantLayoutAnimation from "./instantLayout/InstantLayoutAnimation.vue";

export default {
  name: "InstantsGames",
  components: {
    InstantLayoutGenerator,
    InstantLayoutAnimation,
  },
  props: {},
  mounted() {
    const cfg = store.clientConfig;
    const group = cfg && cfg["Instant"] ? cfg["Instant"] || [] : [];
    this.games = Array.isArray(group) ? group : [];
  },
  data() {
    return {
      isWaitingForServer: false,
      chosenGame: null,
      store: store,
      currentCorrelationId: "",
      currentStatus: "",
      unfinishedTickets: [],
      lastTicketResult: null,
      games: [],
    };
  },
  methods: {
    formatPrice,
    chooseGame(_game) {
      this.chosenGame = _game;
      this.checkUnfinishedTickets();
      this.lastTicketResult = null;
    },
    checkUnfinishedTickets() {
      getUnfinishedTickets(this.chosenGame.id)
        .then((data) => {
          data.sort(
            (a, b) =>
              new Date(a.tickets[0].autoCompleteOn) -
              new Date(b.tickets[0].autoCompleteOn),
          );
          this.unfinishedTickets = data;
        })
        .catch(() => {
          this.unfinishedTickets = null;
        });
    },
    buy() {
      this.lastTicketResult = null;
      unifiedBuy({
        game: this.chosenGame,
        buyOverrides: {
          pluginGameId: this.chosenGame.buyTicketMeta.gameId,
          wager: getSuggestedWager(this.chosenGame) || 0,
        },
        setLoading: (v) => {
          this.isWaitingForServer = v;
        },
        refreshTickets: () => this.checkUnfinishedTickets(),
        refreshBalance: () => updateBalance(),
        onSuccess: (data) => {
          console.log("buy", this.chosenGame, data);
        },
        onError: (err) => {
          if (typeof err === "string") alert(err);
          else console.error("Instant buy failed", err);
        },
      });
    },
    async finalizeTicket(_ticket) {
      this.isWaitingForServer = true;

      finalizeGameWithCorrelationId(_ticket.correlationId).then((data) => {
        if (!data.tickets) {
          alert("Ticket error");
          this.isWaitingForServer = false;
          return;
        }
        data.tickets.forEach(async (ticket) => {
          console.log("ticket", ticket);
          if (ticket) {
            await getInstantTicket(ticket.id).then((data) => {
              ticket = data;
            });
          } else {
            ticket.prizeValue = 0;
          }
          this.lastTicketResult = ticket;
          console.log("Ticket finalized", ticket);
        });
        this.isWaitingForServer = false;
        this.checkUnfinishedTickets();
        updateBalance();
      });
    },
  },
};
</script>

<style scoped>
ul.list-buttons {
  list-style-type: none;
  padding: 0;
}
ul.list-buttons li {
  display: inline-block;
  margin: 0 10px 10px 0;
}
</style>
